import { PostalCodeRepository } from '@lib/api/repository/postal-code/postal-code.repository';
import { PostalCodeResult } from '@lib/types';

interface ViaCEPResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  estado: string;
  ibge: string;
  erro?: boolean;
}

export default class ViaCEPRepository implements PostalCodeRepository {
  async find(postalCode: string): Promise<PostalCodeResult> {
    const normalized = postalCode.replace(/\D/g, '');

    const response = await fetch(
      `https://viacep.com.br/ws/${normalized}/json/`,
    );

    const data = (await response.json()) as ViaCEPResponse;

    if (!response.ok || data.erro) {
      throw new Error('CEP não encontrado.');
    }

    return {
      postalCode: data.cep,
      street: data.logradouro,
      complement: data.complemento || undefined,
      district: data.bairro,
      city: data.localidade,
      state: data.estado,
      stateCode: data.uf,
      ibgeCode: data.ibge || undefined,
    };
  }
}
